import React, { useRef, useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
  AppstoreOutlined,
  BarsOutlined,
  LogoutOutlined,
  PieChartOutlined,
  SettingOutlined,
  TableOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { SideBar } from "pepsico-ds";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from "../../constants/localStoreKeys";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { urlConstants } from '../../constants/urlConstants';
import { useAuth } from "../../utils/auth/useAuth";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { FetchUserAccessAction } from "../../redux/action/LandingPageAction";

const { Header, Content, Footer, Sider } = Layout;

function Sidebar() {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const [loader, setLoader] = useState(true);
  const [isNavigate, setIsNavigate] = useState("");
  const [activeItemSidebar, setActiveItemSidebar] = useState({});
  const [activeSubLinkSidebar, setActiveSubLinkSidebar] = useState({});
  const isLoading = useSelector((state) => state?.loader?.isLoading);
  // const feedbackFormUrl = window.SIDEBAR_FEEDBACK_FORM_URL;
  const collapsed = useSelector(
    (state) => state?.localData?.data[localStoreKeys.isSideBarCollapsed],
  );
  // console.log("SIDEBAR LOADED")
  const feedbackFormUrl = useSelector(
    (state) => state?.localData?.data?.[localStoreKeys?.feedbackFormUrl],
  );
  const procurementPolicies =
    "https://www.mypepsico.com/wps/myportal/web/MyPepsiCo/company/departments-and-functions/global-procurement/gp-policies/gp-policies/!ut/p/z1/vVPBUoMwEP0VPfSYyUIp0CNF1Far1kpbcmHSEGg6kERKrfr1BseDOqM442gOmdnN2928lxdM8AoTSR9EQRuhJC1NnBA3vfEj93wC9sW15wEEi-shnM5Pg1lk4eUrYHpmudbIgUu4AwOwJoF_cuGD5Qww-Uk9fLEC6KpfYIJJSWURbszGccJlm9FMZDixMo9DNqDIXVOOnJx5aJg7FDkudxxm2TbvQ4tmstHNBieVTg98nTIlGy6btBTrlMseqH19xFSlqXzqQcY1rZvKnO8QlRnK95K1Yu16UJRqTUuka8X2NW8hJqeRVqVggu8-BG_Ev2FGvtdl2V68Q_quHuSTuuMogmAEi5kTDiG8HHSMsC2cGBbelyxiFy8fBD_gWKq6Mnaatx2X4TSdxdGtqf3Vw51D1_j-X46fdFnT_B27nobTwrSlzQYJmSu8eu-BjwFOxPb-ngTGj60BHxu8-k9D6iqOK79foRWIMUom2-d8U1Q3V4gk_i44Pn4BJb9CWw!!/dz/d5/L0lDUmlTUSEhL3dHa0FKRnNBLzROV3FpQSEhL2Vu/";
  const dispatch = useDispatch();
  const location = useLocation();
  const firstIcon = collapsed ? "menu" : "close";

  const userData = useSelector((state) => state.getLandingPageReducer);
  const userAccessData = useSelector((state) => state.getUserAccessReducer);

  const hasIbpAccess = userData?.ismIpbAccess;
  const hasEMEAAccess = userData?.isEMEAUser;
  const hasNaSectorAccess = userAccessData?.isNaSector;
  const isGlobalPackagingUser = userAccessData?.isGlobalPackagingUser;
  const isSupplierPassportUser = userAccessData?.isSupplierPassportUser;
  const hasNpsAccess = userData?.npsRoleDetail?.length > 0;
  const hasNotificationManagerAccess = userData?.notificationAdminAccess;
  const wrapperRef = useRef(null);

  useEffect(() => {
    async function fetchUserInfo() {
      const user = await getUserClaims();
      if (user) {
        dispatch(FetchUserAccessAction(user));
      }
    }
    fetchUserInfo();
  }, []);

  /* istanbul ignore next */
  const sidebarActiveItem = () => {
    if (location.pathname === "/home") {
      setActiveItemSidebar({
        icon: "home",
        label: "Gateway to All Apps",
        url: "/home",
      });
      setActiveSubLinkSidebar({});
    } else if (location.pathname.includes("/overview")) {
      setActiveItemSidebar({
        icon: "track_changes",
        label: "360° KPI Overview",
        url: "/overview",
      });
      setActiveSubLinkSidebar({});
    } else if (location.pathname === "/nps-admin") {
      setActiveItemSidebar({
        icon: "speed",
        label: "NPS Admin Dashboard",
        url: "/nps-admin",
      });
      setActiveSubLinkSidebar({});
    } ///notification-center
    else if (location.pathname === "/notification-center") {
      setActiveItemSidebar({
        icon: "markunread_mailbox",
        label: "Notification Center",
        url: "/notification-center",
      });
      setActiveSubLinkSidebar({});
    } else if (location.pathname === "/category-forums") {
      setActiveItemSidebar({
        icon: "all_inbox",
        label: "Category Forums",
        url: "/category-forums",
      });
      setActiveSubLinkSidebar({});
    } else if (location.pathname === "/global-sector-links") {
      setActiveItemSidebar({
        icon: "public",
        label: "Global / Sector Links",
        url: "/global-sector-links",
      });
      setActiveSubLinkSidebar({});
    } else if (location.pathname.includes("/ai-assistant") 
      || location.pathname.includes("/spend-analytics-ai-agent")
      || location.pathname.includes("/spend-analytics-ai-agent-conversations")) {
      setActiveItemSidebar({
        icon: "auto_awesome",
        label: "AI Assistant",
        url: "/ai-assistant",
      });
      setActiveSubLinkSidebar({});
    } else if (location.pathname === "/agroapplications") {
      setActiveItemSidebar({
        icon: "build",
        label: "User Toolkit",
        sublinks: [
          {
            label: "Agro Apps",
            url: "/agroapplications",
          },
          {
            label: (
              <>
                Value Realization
                <br />
                Dashboard
              </>
            ),
          },
          {
            label: (
              <>
                Procurement
                <br />
                Productivity Framework
              </>
            ),
          },
          // {
          // label: <>Digital Procurement Intake<br />Form</>,
          // },
          {
            label: (
              <>
                Global Procurement
                <br />
                Policies
              </>
            ),
          },
        ],
        url: "/resource",
      });
      setActiveSubLinkSidebar({
        label: "Agro Apps",
        url: "/agroapplications",
      });
    } else if (location.pathname.startsWith("/procurement-capabilities")) {
      setActiveItemSidebar({
        icon: "school",
        label: "Knowledge Base",
        sublinks: [
          {
            label: <>Procurement Capabilities</>,
            url: "/procurement-capabilities",
          },
          {
            label: "Digital Library",
          },
          {
            label: <>Procurement Taxonomy 2.0</>,
            url: "/taxonomy",
          },
        ],
        url: "/components",
      });
      setActiveSubLinkSidebar({
        label: "Procurement Capabilities",
        url: "/procurement-capabilities",
      });
    } else if (location.pathname === "/taxonomy") {
      setActiveItemSidebar({
        icon: "school",
        label: "Knowledge Base",
        sublinks: [
          {
            label: <>Procurement Capabilities</>,
            url: "/procurement-capabilities",
          },
          {
            label: "Digital Library",
          },
          {
            label: <>Procurement Taxonomy 2.0</>,
            url: "/taxonomy",
          },
        ],
        url: "/components",
      });
      setActiveSubLinkSidebar({
        label: "Procurement Taxonomy 2.0",
        url: "/taxonomy",
      });
    }
  };
  /* istanbul ignore next */
  useEffect(() => {
    sidebarActiveItem();
  }, []);

  let items = [
    {
      icon: "home",
      label: "Gateway to All Apps",
      url: "/home",
    },
    {
      icon: "track_changes",
      label: "360° KPI Overview",
      url: "/overview",
    },
  ];

  // AI Assistant menu - Hidden as it will be a blinking icon
  // if (true) {
  //   items.push(
  //   {
  //     icon: "auto_awesome",
  //     label: "AI Assistant",
  //     url: "/ai-assistant",
  //   });
  // }

  // NPS menu
  if (hasNpsAccess) {
    items.push({
      icon: "speed",
      label: "NPS Admin Dashboard",
      url: "/nps-admin",
    });
  }

  // Notification Manager menu
  if (hasNotificationManagerAccess) {
    items.push({
      icon: "markunread_mailbox",
      label: "Notification Center",
      url: "/notification-center",
    });
  }

  // Category Forums menu - always visible
  items.push({
    icon: "all_inbox",
    label: "Category Forums",
    url: "/category-forums",
  });

  if (hasEMEAAccess || hasNaSectorAccess || isSupplierPassportUser || isGlobalPackagingUser) { //
    items.push({
      icon: "language",
      label: "Global / Sector Links",
      url: "/global-sector-links",
    });
  }
  

  let commonSidebarVal = [
    {
      icon: "build",
      label: "User Toolkit",
      sublinks: [
        {
          label: "Agro Apps",
          url: "/agroapplications",
        },
        ...(hasIbpAccess
          ? [
              {
                icon: "webhook",
                label: "IBP-ISP",
              },
            ]
          : []),
        {
          label: (
            <>
              Value Realization
              <br />
              Dashboard
            </>
          ),
        },
        {
          label: (
            <>
              Procurement
              <br />
              Productivity Framework
            </>
          ),
        },
        // {
        // label: <>Digital Procurement Intake<br />Form</>,
        // },
        {
          label: (
            <>
              Global Procurement
              <br />
              Policies
            </>
          ),
        },
      ],
      url: "/resource",
    },
    {
      icon: "school",
      label: "Knowledge Base",
      sublinks: [
        {
          label: <>Procurement Capabilities</>,
          url: "/procurement-capabilities",
        },
        {
          label: "Digital Library",
        },
        {
          label: "Procurement Taxonomy 2.0",
          url: "/taxonomy",
        },
      ],
      url: "/components",
    },
  ];

  items.push(...commonSidebarVal);

  useEffect(() => {
    setLoader(false);
  }, [userData]);

  useEffect(() => {
    sidebarActiveItem();
  }, [location.pathname]); // or dependency you need
  // }, [location.pathname, isNavigate]); // or dependency you need

  /* istanbul ignore next */
  const selectMenu = (e) => {
    console.log(e);
    if (e.label?.props?.children[0] === "Value Realization") {
      window.open(urlConstants.valueRealizationDB, "_blank", "noopener");
    } else if (e.label?.props?.children[0] === "Global Procurement") {
      window.open(procurementPolicies, "_blank", "noopener");
    } else if (e.label === "Feedback") {
      window.open(feedbackFormUrl, "_blank", "noopener");
    } else if (e.label === "IBP-ISP") {
      window.open(urlConstants.ismIBP, "_blank", "noopener");
    } else if (e.label === "Digital Library") {
      window.open(urlConstants.testimonials, "_blank", "noopener");
    }
    // else if (e.label?.props?.children[0] === "Digital Procurement Intake") {
    //     window.open(urlConstants.procurementIntakeForm, "_blank", "noopener")
    // }
    else if (e.label?.props?.children[0] === "Procurement") {
      window.open(urlConstants.productivityFramework, "_blank", "noopener");
    } else if (e.label === "User Toolkit" || e.label === "Knowledge Base") {
      return;
    } else {
      navigate(e.url);
    }

    setIsNavigate(e?.label);
  };

  /* istanbul ignore next */
  useEffect(() => {
    if (!wrapperRef.current) return;

    const applyDataAttributes = () => {
      const subDiv = wrapperRef.current.querySelector(".sidebar-content");

      if (subDiv && subDiv.children.length > 0) {
        Array.from(subDiv.children).forEach((child) => {
          const iconSpan = child.querySelector("span[aria-label]");

          if (iconSpan) {
            const labelValue = iconSpan.getAttribute("aria-label");
            const newValue = `ph-main-option-${labelValue}`;

            if (child.getAttribute("data-fs") !== newValue) {
              child.setAttribute("data-fs", newValue);
            }
            if (child.getAttribute("aria-label") !== newValue) {
              child.setAttribute("aria-label", newValue);
            }
          }

          const subMenu = child.querySelector(".floating-menu");
          if (subMenu && subMenu.children.length > 0) {
            Array.from(subMenu.children).forEach((child, index) => {
              const labelValue = `ph-sub-option-${child.querySelector("span")?.textContent}`;
              if (child.getAttribute("data-fs") !== labelValue) {
                child.setAttribute("data-fs", labelValue);
              }
              if (child.getAttribute("aria-label") !== labelValue) {
                child.setAttribute("aria-label", labelValue);
              }
            });
          }

          const subMenuExpanded = child.querySelectorAll(".submenu-item");

          if (subMenuExpanded && subMenuExpanded.length > 0) {
            Array.from(subMenuExpanded).forEach((child, index) => {
              const labelValue = `ph-sub-option-${child.querySelector("span")?.textContent}`;
              if (child.getAttribute("data-fs") !== labelValue) {
                child.setAttribute("data-fs", labelValue);
              }
              if (child.getAttribute("aria-label") !== labelValue) {
                child.setAttribute("aria-label", labelValue);
              }
            });
          }
        });
      }
    };

    const observer = new MutationObserver(applyDataAttributes);

    observer.observe(wrapperRef.current, {
      childList: true,
      subtree: true,
    });

    applyDataAttributes();

    return () => observer.disconnect();
  }, []);

  /* istanbul ignore next */
  // if(authState?.isAuthenticated){
  return (
    <span ref={wrapperRef}>
      <div
        className="buy-con-sidebar"
        style={{ display: "flex", height: "100%" }}
      >
        {/* <div className="buy-con-sidebar"> */}
        {loader ? (
          <></>
        ) : (
          <>
            <SideBar
              activeItem={activeItemSidebar}
              activeSubLink={activeSubLinkSidebar}
              className=""
              collapseWidth="72px"
              height="100%"
              isOverlay
              isShow
              items={items}
              navLinkAction={selectMenu}
              onAppClick={function ERe() {}}
              showCollapsed
              style={{}}
              variant="default"
              width="300px"
            />
          </>
        )}
      </div>
    </span>
  );
  // }
}

export default React.memo(Sidebar);
